import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

/* IMPORT ALL STYLES */
import "./index.css";
import "./styles/global.css";
import "./styles/navbar.css";
import "./styles/hero.css";
import "./styles/about.css";
import "./styles/services.css";
import "./styles/testimonial.css";
import "./styles/contact.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
